import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: 'que-extra-details',
    imports: [CommonModule, TranslateDirective, TranslatePipe],
    templateUrl: './extra-details.component.html',
    styleUrls: ['./extra-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExtraDetailsComponent {
  @Input() requiredAmount?: number | null;
  @Input() approvedAmount?: number | null;
  @Input() expenseRowsCount?: number | null;
  @Input() comment?: string | null;

  @HostBinding('class.amount-mismatch')
  get hasAmountMismatch(): boolean {
    return this.requiredAmount != null && this.approvedAmount != null && this.requiredAmount !== this.approvedAmount;
  }
}
